module.exports = "https://img.xiyuyouxi.com/saas/img/finish_mark.29bc6ddc.png";